<template>
  <div class="section">
    <div v-if="isMaxScreen" class="page pc_page-1">
        <!-- v-if="showVideo" -->
      <!-- <video
        id="video"
        ref="video"
        autoplay
        muted
        preload="auto"
        playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="allow"
        airplay="allow"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portrait"
        :poster="isES ? esPcBanner : enPcBanner"
        :src="isES ? esPcBannerVideo : enPcBannerVideo"
        @click="handleJumpToPage"></video> -->
      <img :src="isES ? esPcBanner : enPcBanner" alt="" class="banner-image"   @click="handleJumpToPage"/>
      
    </div>

    <div v-else class="page page-1">
      <div class="banner-image-container" @click="handleJumpToPage">
        <img :src="mbBannerSrc" alt="" class="banner-image" />
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isES } from '@/locales';
export default {
  name: 'section1',
  components: {},
  data() {
    return {
      showGif: false,
      // showVideo: true,
      esPcBannerVideo: require('../../../assets/image/eu-home/es-pc-banner-video.mp4'),
      enPcBannerVideo: require('../../../assets/image/eu-home/en-pc-banner-video.mp4'),
      // esPcBanner: require('../../../assets/image/eu-home/es-pc-banner.png'),
      esPcBanner: require('../../../assets/image/eu-home/es-vivo-banner.png'),
      // enPcBanner: require('../../../assets/image/eu-home/en-pc-banner.png'),
      enPcBanner: require('../../../assets/image/eu-home/en-vivo-banner.png'),
      esMbGif: require('../../../assets/image/eu-home/es-mb-banner.gif'),
      enMbGif: require('../../../assets/image/eu-home/en-mb-banner.gif'),
      esMbPic: require('../../../assets/image/eu-home/es-mb-banner.png'),
      enMbPic: require('../../../assets/image/eu-home/en-mb-banner.png'),
      isES
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    }),
    mbBannerSrc(){
      return this[`${this.isES ? 'es' : 'en'}Mb${this.showGif ? 'Gif' : 'Pic'}`]
    }
  },
  mounted(){
    // setTimeout(() => {
    //   this.showGif = false
    // }, 5800)
    // const myVideo = document.getElementById("video")
    // myVideo.addEventListener("ended", () => {
    //   this.$nextTick(() => {
    //     this.showVideo = false
    //   })
    // })
  },
  methods: {
    handleJumpToPage(){
      // 跳到回收
      this.$router.push({ name: 'Product' });
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
    }
    .pc_page-1 {
      padding-top: 100px;
      video {
        max-width: 100%;
        height: auto;
      }
      .banner-image{
        // width: 100%;
      }
    }
  }
}
@media (max-width: 980px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
    }
    .page-1 {
      padding-top: 100px;
      .banner-image-container{
        width: 100%;
        .banner-image{
          width: 100%;
        }
      }
    }
  }
}
</style>
